var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-7"},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.heading)+" ")]),_c('v-spacer')],1),_c('v-divider'),_c('div',{staticClass:"pa-4"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }